/* eslint-disable camelcase,no-empty-pattern */

import Vue from 'vue'
import Vuex from 'vuex'
import TEST_METHOD_CONFIG from '@/config/test-methods'

import builderStore from '@/state/builder'
import testStore from '@/state/tests'
import walletStore from '@/state/wallet'
import projectAuthor from '@/state/projectAuthor'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    builder: builderStore,
    test: testStore,
    wallet: walletStore,
    projectAuthor: projectAuthor
  },
  state: {
    testMethods: TEST_METHOD_CONFIG,
    viewportWidth: null,
    viewportHeight: null,
    noCookiesFlag: false,
    noCaptureFlag: false,
    showDebugDataFlag: false,
    noCookiesPopFlag: false,
    navOnFlag: false
  },
  mutations: {
    setViewportDimensions (state, payload) {
      state.viewportWidth = payload.width
      state.viewportHeight = payload.height
    },
    setNoCookiesFlag (state, flag) {
      state.noCookiesFlag = flag
    },
    setNoCaptureFlag (state, flag) {
      state.noCaptureFlag = flag
    },
    setNoCookiesPop (state, flag) {
      state.noCookiesPopFlag = flag
    },
    setShowDebugDataFlag (state, flag) {
      state.showDebugDataFlag = flag
    },
    setNavOn (state, flag) {
      state.navOnFlag = flag
    }
  },
  getters: {
    testMethods (state) {
      return state.testMethods
    }
  },
  actions: {
    setQueryVars ({ commit }, { noCookies, noCapture, noCookiesPop, navOn, showDebugData }) {
      commit('setNoCookiesFlag', noCookies)
      commit('setNoCaptureFlag', noCapture)
      commit('setNoCookiesPop', noCookiesPop)
      commit('setNavOn', navOn)
      commit('setShowDebugDataFlag', showDebugData)
    }
  }
})
